import React from 'react';
import { useQuery } from '@apollo/client';
import WearableConnectionsQuery from './WearableConnectionsQuery';
import type { WearableConnection } from '../types';

interface Result {
  loading: boolean;
  connections: WearableConnection[];
  refetch: () => void;
}

interface Props {
  children: (result: Result) => React.ReactElement;
}

const WearableConnectionsConnectorApollo: React.FC<Props> = ({ children }) => {
  const { loading, data, error, refetch } = useQuery(WearableConnectionsQuery, {
    fetchPolicy: 'cache-and-network',
  });

  if (error) throw error;

  return children({
    loading,
    connections: data?.wearable?.connections ?? [],
    refetch,
  });
};

export default WearableConnectionsConnectorApollo;
